import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  AfterViewInit,
  OnDestroy
} from "@angular/core";
import { from } from "rxjs";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Router } from "@angular/router";
@Component({
  selector: "highlight-block",
  templateUrl: "./highlight-block.component.html",
  styleUrls: ["./highlight-block.component.scss"]
})
export class HighlightBlockComponent implements OnInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  mockData = {
    "data": [
      {
        "bucket": "month",
        "percentage": 100,
        "comparison": 100
      }
    ]
  };

  @Input() TITLE = "";
  @Input() DATA = null;
  @Input() TEXT = "";
  @Input() MOCKDATA = false;
  @Input() DATALOADING = false;
  @Input() DONTCOMPARE = false;

  message = ''

  panel: any = {};

  constructor(
   private router: Router
  ) { }

  ngOnInit() { 
    this.message = this.router.url.includes('outbound') ? 'WAREHOUSE.HIGHLIGHT_OUTBOUND_MSG' : 'WAREHOUSE.HIGHLIGHT_INBOUND_MSG';
  }

  shortenedText(text) {
    if (text.indexOf("Yesterday") > -1 && text.length >= 14) {
      return `YEST ${text.substr(12)}`;
    }
    if (text.indexOf("Yesterday") > -1) {
      return `YEST ${text.substr(10)}`;
    }

    if (text.indexOf("Month") > -1) {
      return `MTD ${text.substr(14)}`;
    }
    if (text.indexOf("Quarter") > -1) {
      return `QTD ${text.substr(16)}`;
    }
    if (text.indexOf("Overall SLA") > -1) {
      return `SLA ${text.substr(16)}`;
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
